/**
 * Transform new report data format to old chart format
 *
 * New format: [{Name: "New", Total: 12, TotalAmount: 0, New: 12}, ...]
 * Old format: {New: 12, Pending: 5, Delivered: 2, ...}
 *
 * @param {Array} data - The new format data array
 * @returns {Object} - The old format data object
 */
export const transformReportDataForCharts = (data) => {
  console.log("transformReportDataForCharts input:", data);

  if (!data || !Array.isArray(data) || data.length === 0) {
    console.log(
      "transformReportDataForCharts: returning data as-is (empty/invalid)"
    );
    return data;
  }

  // Check if this is the date-based format (has Name and Total properties)
  if (
    data[0] &&
    data[0].hasOwnProperty("Name") &&
    data[0].hasOwnProperty("Total")
  ) {
    // For time-series charts, keep the array shape when `Name` looks like a date bucket.
    // We support:
    // - monthly/yearly buckets: "MM-YYYY"
    // - daily/weekly buckets:   "MM-DD-YYYY"
    // - slash format (legacy):  "MM/DD/YYYY"
    const name = data[0].Name || "";
    const isDateBased =
      typeof name === "string" &&
      (/^\d{2}-\d{4}$/.test(name) ||
        /^\d{2}-\d{2}-\d{4}$/.test(name) ||
        /^\d{2}\/\d{2}\/\d{4}$/.test(name));

    if (isDateBased) {
      // console.log("Job chart date-based data - returning array as-is");
      return data;
    } else {
      // This is status-based data, transform to object format
      // console.log(
      //   "Job chart status-based data - transforming to object format"
      // );
      const transformedData = data.reduce((acc, item) => {
        acc[item.Name] = item.Total;
        return acc;
      }, {});
      return transformedData;
    }
  }

  // If it's already in the old format, return as is
  // console.log(
  //   "transformReportDataForCharts: returning data as-is (old format)"
  // );
  return data;
};
